import  './RentShieldPage.css';
import GuestProtection from '../GuestProtection/GuestProtection';
import Lottie from 'react-lottie';
import animationData from './animation/Certificate-gradient-hover.json'
 
const RentShieldPage = ()=>{

    const defaultOptions = {
        loop: true,       
        autoplay: true,     
        animationData: animationData,
      };
    

    return(
        <>

            {/* START bannerInnerMain */}
            <section className="bannerInnerMain bannerShieldMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="bannerPageInner">
                                <figure><img src="/img/rentshield/rentShield_icon_banner.svg" alt="babber"/></figure>
                                <h1>Commercial auto insurance & protection for rental, ride share, and delivery</h1>
                                <p>Customizable liability and physical damage coverages, plus roadside assistance designed 
                                  specifically for car rental operators and their guests. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerInnerMain */}


            {/* START insuranceSecMain */}
            <section className='insuranceSecMain' id='insurancesec'>  
                <img className="primary_1" src="/img/rentshield/primary_1.svg" alt="COMMERCIAL AUTO INSURANCE & PROTECTION"/>
                <div className='container'>
                      <div className='row align-items-end'>
                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                            <div className='insuranceLeft'>
                                <h6>COMMERCIAL AUTO INSURANCE & PROTECTION</h6>
                                <h3>Dynamic On-Rent Coverage & Protection Plans for Rental Fleets</h3>
                                <p>Comprehensive solutions to protect your rentals, manage incidents, and keep operations running 
                                smoothly. Get support for on-trip issues, efficient claim handling, and flexible 
                                coverage settings.</p>
                                <ul className='insurance-list'>
                                    <li>
                                        <a href="#CommercialAutoInsurance">
                                            <img width="24px" height="24px"src="/img/commercial_icon.svg" alt="commercial_icon" />
                                            Commercial Auto Insurance
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#GuestProtectionPlans">
                                            <img width="24px" height="24px"src="/img/guest_icon.svg" alt="car-shield" />
                                            Guest Protection Plans
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#NationalRoadsideAssistance">
                                            <img width="24px" height="24px"src="/img/tow_truck_icon.svg" alt="user" />
                                            National Roadside Assistance
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#DigitalClaimsManagement">
                                            <img width="24px" height="24px"src="/img/claims_management_icon.svg" alt="tow truck" />
                                            Digital Claims Management
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#CoverageSettings">
                                            <img width="24px" height="24px"src="/img/settings_icon.svg" alt="web protection" />
                                            Coverage Settings
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#InsuranceServicesFAQ">
                                            <img width="24px" height="24px"src="/img/book_open_icon.svg" alt="digital" />
                                            Insurance Services FAQ
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                            <div className='insuranceRight'>
                                <div className='insuranceRightImage'>
                                    <img className="img-fluid" src="/img/rentshield/insurance-img.webp" alt="insurance" />
                            
                                </div>
                                    <div className='auto-insurance-sec'>
                                        <div className='auto-insurance'>
                                            <img src="/img/featured-img1.svg" alt="liablity" />    
                                            <div class='inner-text-sec'>
                                                <h5>A-Rated Auto Insurance</h5>
                                                <p>Industry leading commercial auto insurance</p>
                                            </div>
                                        </div>
                                        <div className='auto-insurance left-space-box'>
                                            <img src="/img/featured-img1.svg" alt="liablity" />   
                                            <div class='inner-text-sec'>
                                                <h5>On Demand Coverages</h5>
                                                <p>Choose from four types of coverage plans</p>
                                            </div>
                                        </div>
                                        <div className='auto-insurance left-space-box1'>
                                            <img src="/img/featured-img1.svg" alt="liablity" />   
                                            <div class='inner-text-sec'>
                                                <h5>Automated Peace of Mind</h5>
                                                <p>Manually or auto accept based on coverages</p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>

                      </div>
                </div>
            </section>
            {/* END insuranceSecMain */}


            {/* START primaryCommercialMain */}
            <section className='primaryCommercialMain' id='CommercialAutoInsurance'>
                <img className="primary_2" src="/img/rentshield/shadowPrimary.svg" alt="rent id"/>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='primaryCommercialhead'>
                                <img className="img-fluid" src="/img/rentshield/power_shield.svg" alt="power shield"/>
                                <h2>Primary Commercial Auto Insurance<span> exclusively for rental vehicles</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='primaryCommercialInner'>
                                <a href="/primary-commericial" className="btn pinkBtn">Learn More<img src="/img/rentshield/arrow_white.svg" alt="icon"/></a>
                                <span><Lottie options={defaultOptions} /></span>
                                <img className="a_rated_insurance" src="/img/rentshield/a_rated_insurance.png" alt="rent id"/>
                                <figure className="primary_img_desk">
                                    <img className="img-fluid" src="/img/rentshield/primary_img.png" alt="rent id"/>
                                </figure>
                               
                                <figure className="primary_img_mobile">
                                    <img className="img-fluid" src="/img/rentshield/primary_img_mobile.svg" alt="rent id"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END primaryCommercialMain */}
 

            <GuestProtection/> 


            {/* START roadsideAssistanceMain */}
            <section className='roadsideAssistanceMain' id='NationalRoadsideAssistance'>
            <img className="roadsideAssistance_1" src="/img/rentshield/roadsideAssistance_1.svg" alt="Roadside Assistance"/>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-lg-9 col-md-12 col-sm-12 col-12'>
                        <div className='roadsideAssistanceHead'>
                            <h2>National Roadside Assistance <span>whenever, wherever...you’re covered.</span></h2>
                            <p>Enjoy peace of mind and support your renters with our 24/7 <span>Standard and Plus Roadside Assistance Plans.</span> 
                            From basic coverage to enhanced protection, choose the plan that fits your needs and keeps your vehicle and 
                            guests safe.</p>
                        </div>
                    </div>
                </div>
                {/* start sec row */}
                <div className='row'>
                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className='roadsideAssistanceLeft'>
                            <img className="imgfluid" src="/img/rentshield/rentshield_ roadside assistance.webp" alt="Roadside Assistance"/>
                        </div>
                    </div>
             

                     {/* <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className='roadsideAssistanceTop'>
                            <div className='roadsideAssistanceInn'>
                                <div className="roadsideAssistanceInner">
                                    <h3>Standard Plan</h3>
                                    <h4>Plan includes:</h4>
                                    <ul>
                                        <li>
                                            <img src="/img/tow_truck_icon.svg" alt="truck"/><span>10-mile towing to your chosen location</span>
                                        </li>
                                        <li>
                                            <img src="/img/battery_icon.svg" alt="battery"/><span>Battery jump-starts</span>
                                        </li>
                                        <li>
                                            <img src="/img/fuel_icon.svg" alt="Fuel"/><span>Fuel delivery service</span>
                                        </li>
                                        <li>
                                            <img src="/img/oil_icon.svg" alt="Oil Delivery"/><span>Emergency oil delivery</span>
                                        </li>
                                        <li>
                                            <img src="/img/tier_icon.svg" alt="Tire change"/><span>Tire change or replacement assistance</span>
                                        </li>
                                    </ul>
                                    <div className="roadsidePolicy">
                                        <a href="#">Read Policy Information </a>
                                    </div>
                                    <div className="roadsideBtn">
                                        <a href="#" className="btn">Select</a>
                                    </div>
                                </div>
            
                                <div className="roadsideAssistanceInner roadsideAssistanceInner_2">
                                    <h3>Plus Plan</h3>
                                    <h4>Plan includes:</h4>
                                    <ul>
                                        <li>
                                            <img src="/img/tow_truck_icon.svg" alt="truck"/><span>25-mile towing to your chosen location</span>
                                        </li>
                                        <li>
                                            <img src="/img/battery_icon.svg" alt="battery"/><span>Battery jump-starts</span>
                                        </li>
                                        <li>
                                            <img src="/img/fuel_icon.svg" alt="Fuel"/><span>Fuel delivery service</span>
                                        </li>
                                        <li>
                                            <img src="/img/oil_icon.svg" alt="Oil Delivery"/><span>Emergency oil delivery</span>
                                        </li>
                                        <li>
                                            <img src="/img/tier_icon.svg" alt="Tire change"/><span>Tire change or replacement assistance</span>
                                        </li>
                                    </ul>
                                    <div className="roadsidePolicy">
                                        <a href="#">Read Policy Information </a>
                                    </div>
                                    <div className="roadsideBtn">
                                        <a href="#" className="btn btnGradient">Added!</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  */}
                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className="roadsideAssistanceFlex">
                            <div className="roadsideAssistanceGrid">
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/tow_truck_green.svg" alt="icon"/>
                                    <h3>Emergency Towing<br/> Services</h3>
                                </div>
        
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/battery_green.svg" alt="icon"/>
                                    <h3>Battery Jump-<br/>Start Service</h3>
                                </div>
            
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/tire_green.svg" alt="icon"/>
                                    <h3>Flat Tire<br/> Changes</h3>
                                </div>
    
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/fuel_green.svg" alt="icon"/>
                                    <h3>Fuel<br/> Delivery</h3>
                                </div>
        
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/key_green.svg" alt="icon"/>
                                    <h3>Lockout<br/> Assistance</h3>
                                </div>
    
                                <div className="roadsideAssistanceRight">
                                    <img className="img-fluid" width="32px" height="32px" src="/img/emergency_green.svg" alt="icon"/>
                                    <h3>Emergency<br/> Extraction</h3>
                                </div>
                            </div>
                        </div>

                        <div className='roadsideAssistanceRightBottom'>
                            <p>Easily add or remove our comprehensive roadside assistance program, available anytime across the U.S. Included for free with monthly subscription.</p> 
                        </div>
                    </div>
                </div>
                {/* end sec row */}
            </div>
            </section>
            {/* END roadsideAssistanceMain */}
   

        </>
    )
}

export default RentShieldPage;